export default __webpack_public_path__ + "static/type-it-light-mode-b2e53da2144ad3ff89eb15acf35cd807.mp4";